import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../app.state';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as actions from './actions';
import { ClubsService } from '../../services/clubs.service';
import { AlertService } from '../../services/alert.service';
import { switchMap, catchError, map } from 'rxjs/operators';

@Injectable()
export class ClubsEffects {
  constructor(
    protected store: Store<AppState>,
    protected service: ClubsService,
    protected action$: Actions,
    private alertService: AlertService
  ) { }

  GetClubs$ = createEffect(() => this.action$.pipe(
    ofType<actions.GetClubsListAction>(actions.GET_CLUBS_LIST),
    switchMap(action => this.service.getClubs().pipe(
      map((result) => new actions.GetClubsListActionSuccess(result)),
      catchError(error => {
        this.alertService.error(error);
        return of(new actions.GetClubsListActionError(error));
      })))));
}
